import Emitter from 'es6-event-emitter';
import $ from 'jquery';

export default class OP3Form extends Emitter {
    /**
     * Init OP3 forms
     *
     * @param $
     */
    constructor($) {
        super();
    }

    /**
     * Make a form post request
     *
     * @param $form
     * @param url
     * @param data
     */
    postRequest($form, url, data) {
        $.ajax({
            method: "POST",
            url: url,
            data: data
        }).done((result) => {
            this.trigger('OP3Form:postRequest', result, $form, url, data);
        }).fail((jqXHR, textStatus) => {
            let result = {};
            result.success = false;
            result.jqXHR = jqXHR;
            result.textStatus = textStatus;

            this.trigger('OP3Form:postRequest', result, $form, url, data);
        });
    }
}
